// extracted by mini-css-extract-plugin
export var askAiIcon = "_mv-9";
export var container = "_mv-0";
export var groupSeparator = "_mv-a";
export var highlight = "_mv-4";
export var resultIcon = "_mv-5";
export var resultItem = "_mv-7";
export var resultSubtitle = "_mv-3";
export var resultTitle = "_mv-2";
export var resultsList = "_mv-1";
export var searchGroup = "_mv-6";
export var selected = "_mv-8";